<h2 mat-dialog-title *ngIf="!update">New booking</h2>
<h2 mat-dialog-title *ngIf="update">Edit booking</h2>

<div mat-dialog-content class="dialog">
  <div style="display: flex; flex-direction: column; gap: 1rem">
    <span *ngIf="update === true" style="font-size: 10px">
      <i>
        Created by <u>{{ createdByName }}</u> {{ createdAt | date : 'dd/MM/yyyy HH:mm' }}<br />
        <i>Edited {{ updatedAt | date : 'dd/MM/yyyy HH:mm' }}</i>
      </i>
    </span>

    <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 12px">
      <!-- Dates / heures -->
      <mat-form-field appearance="outline" class="ff-compact">
        <mat-label>Start date</mat-label>
        <input matInput [matDatepicker]="dp1" [(ngModel)]="dateStart" />
        <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
        <mat-datepicker #dp1></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline" class="ff-compact">
        <mat-label>Start hour</mat-label>
        <input matInput type="time" [(ngModel)]="timeStart" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="ff-compact">
        <mat-label>End date</mat-label>
        <input matInput [matDatepicker]="dp2" [(ngModel)]="dateEnd" />
        <mat-datepicker-toggle matSuffix [for]="dp2"></mat-datepicker-toggle>
        <mat-datepicker #dp2></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline" class="ff-compact">
        <mat-label>End hour</mat-label>
        <input matInput type="time" [(ngModel)]="timeEnd" />
      </mat-form-field>

      <!-- Avion -->
      <mat-form-field appearance="outline" class="ff-compact">
        <mat-label>Aircraft</mat-label>
        <input #aircraftInput type="text" matInput [formControl]="aircraftCtrl" [matAutocomplete]="autoAircraft" />

        <!-- Clear suffix -->
        <button
          *ngIf="aircraftCtrl.value"
          mat-icon-button
          matSuffix
          type="button"
          class="clear-btn"
          aria-label="Effacer la sélection"
          (click)="clearSelection('aircraft'); $event.stopPropagation()"
        >
          ×
        </button>

        <mat-autocomplete
          #autoAircraft="matAutocomplete"
          [displayWith]="displayAircraft.bind(this)"
          (opened)="focusAircraftSearchBox()"
          (closed)="resetAircraftSearch()"
        >
          <!-- Bandeau de recherche dans le panel (non sélectionnable) -->
          <mat-option class="search-option" [value]="null" [tabindex]="-1" aria-disabled="true" (onSelectionChange)="$event.source.deselect?.()">
            <!-- hitbox couvrant 100% de l’option -->
            <div class="search-hitbox" (mousedown)="focusAircraftSearchBox(); $event.stopPropagation()" (click)="$event.stopPropagation()">
              <input
                #aircraftPanelSearch
                type="text"
                class="search-input"
                placeholder="Search..."
                [formControl]="aircraftSearchCtrl"
                autocomplete="off"
                autocorrect="off"
                autocapitalize="none"
                spellcheck="false"
                inputmode="search"
                enterkeyhint="search"
                (mouseup)="$event.preventDefault()"
                (click)="$event.stopPropagation()"
                (keydown)="$event.stopPropagation()"
                (keydown.enter)="$event.preventDefault()"
              />
            </div>
          </mat-option>

          <mat-option *ngFor="let a of filteredAircraftsInPanel" [value]="a">
            {{ a.code }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>

      <!-- Instructeur (même pattern qu'Avion) -->
      <mat-form-field appearance="outline" class="ff-compact">
        <mat-label>Instructor</mat-label>
        <input #instructorInput type="text" matInput [formControl]="instructorCtrl" [matAutocomplete]="autoInstr" />

        <!-- Clear suffix -->
        <button
          *ngIf="instructorCtrl.value"
          mat-icon-button
          matSuffix
          type="button"
          class="clear-btn"
          aria-label="Effacer la sélection"
          (click)="clearSelection('instructor'); $event.stopPropagation()"
        >
          ×
        </button>

        <mat-autocomplete
          #autoInstr="matAutocomplete"
          [displayWith]="displayInstructor.bind(this)"
          (opened)="focusInstructorSearchBox()"
          (closed)="resetInstructorSearch()"
        >
          <mat-option class="search-option" [value]="null" [tabindex]="-1" aria-disabled="true" (onSelectionChange)="$event.source.deselect?.()">
            <!-- hitbox couvrant 100% de l’option -->
            <div class="search-hitbox" (mousedown)="focusInstructorSearchBox(); $event.stopPropagation()" (click)="$event.stopPropagation()">
              <input
                #instructorPanelSearch
                type="text"
                class="search-input"
                placeholder="Search..."
                [formControl]="instructorSearchCtrl"
                autocomplete="off"
                autocorrect="off"
                autocapitalize="none"
                spellcheck="false"
                inputmode="search"
                enterkeyhint="search"
                (mouseup)="$event.preventDefault()"
                (click)="$event.stopPropagation()"
                (keydown)="$event.stopPropagation()"
                (keydown.enter)="$event.preventDefault()"
              />
            </div>
          </mat-option>

          <mat-option *ngFor="let i of filteredInstructorsInPanel" [value]="i">
            {{ i.name }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>

      <!-- Élève (si INSTRUCTOR) — même pattern -->
      <ng-container *ngIf="authService.currentUser?.role === 'INSTRUCTOR'">
        <mat-form-field appearance="outline" class="ff-compact">
          <mat-label>Pilot</mat-label>
          <input #studentInput type="text" matInput [formControl]="studentCtrl" [matAutocomplete]="autoStud" />

          <!-- Clear suffix -->
          <button
            *ngIf="studentCtrl.value"
            mat-icon-button
            matSuffix
            type="button"
            class="clear-btn"
            aria-label="Effacer la sélection"
            (click)="clearSelection('student'); $event.stopPropagation()"
          >
            ×
          </button>

          <mat-autocomplete
            #autoStud="matAutocomplete"
            [displayWith]="displayStudent.bind(this)"
            (opened)="focusStudentSearchBox()"
            (closed)="resetStudentSearch()"
          >
            <mat-option class="search-option" [value]="null" [tabindex]="-1" aria-disabled="true" (onSelectionChange)="$event.source.deselect?.()">
              <!-- hitbox couvrant 100% de l’option -->
              <div class="search-hitbox" (mousedown)="focusStudentSearchBox(); $event.stopPropagation()" (click)="$event.stopPropagation()">
                <input
                  #studentPanelSearch
                  type="text"
                  class="search-input"
                  placeholder="Search..."
                  [formControl]="studentSearchCtrl"
                  autocomplete="off"
                  autocorrect="off"
                  autocapitalize="none"
                  spellcheck="false"
                  inputmode="search"
                  enterkeyhint="search"
                  (mouseup)="$event.preventDefault()"
                  (click)="$event.stopPropagation()"
                  (keydown)="$event.stopPropagation()"
                  (keydown.enter)="$event.preventDefault()"
                />
              </div>
            </mat-option>

            <mat-option *ngFor="let s of filteredStudentsInPanel" [value]="s">
              {{ s.name }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </ng-container>

      <!-- <mat-form-field appearance="outline" class="full">
        <mat-label>Places libres</mat-label>
        <mat-select placeholder="Places libres...">
          <mat-option> 1 </mat-option>
          <mat-option> 2 </mat-option>
          <mat-option> 3 </mat-option>
          <mat-option> 4 </mat-option>
          <mat-option> 5 </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full">
        <mat-label>Catégorie</mat-label>
        <mat-select placeholder="Catégorie...">
          <mat-option> Training flight </mat-option>
          <mat-option> Club activity </mat-option>
          <mat-option> Private flight </mat-option>
          <mat-option> Maintenance </mat-option>
        </mat-select>
      </mat-form-field> -->

      <div style="display: flex; flex-direction: row">
        <mat-checkbox>Solo</mat-checkbox>
        <!-- <mat-checkbox>Training</mat-checkbox> -->
      </div>

      <mat-form-field class="fullWidth">
        <mat-label>Remarks</mat-label>
        <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="3" cdkAutosizeMaxRows="3"></textarea>
      </mat-form-field>
    </div>
  </div>
</div>

<div mat-dialog-actions align="end">
  <button mat-stroked-button (click)="cancel()">Cancel</button>
  <button mat-flat-button color="primary" (click)="save()">Save</button>
</div>
